import { mapProductImagesFromApi } from '@/features/admin-catalog/lib/mapProductImages'
import { mapRestaurant } from '@/entities/restaurant/model/mapRestaurant'

function restaurantPreviewUrl(raw) {
  const images = Array.isArray(raw?.images) ? raw.images : []
  const variants = images[0]?.variants
  if (variants && typeof variants === 'object') {
    const fromVariants =
      String(variants.mid ?? '').trim() ||
      String(variants.default ?? '').trim() ||
      String(variants.small ?? '').trim() ||
      String(variants.large ?? '').trim()
    if (fromVariants) {
      return fromVariants
    }
  }
  return typeof raw?.image_url === 'string' && raw.image_url.trim() ? raw.image_url.trim() : ''
}

export function mapAdminRestaurant(raw) {
  const restaurantImages = mapProductImagesFromApi(raw).slice(0, 1)
  const preview = restaurantPreviewUrl(raw)

  if (restaurantImages[0] && preview && !restaurantImages[0].previewUrl) {
    restaurantImages[0] = { ...restaurantImages[0], previewUrl: preview }
  }

  return {
    ...mapRestaurant(raw),
    restaurantImages,
  }
}
